import { type OpenShiftListItem, type TimeSlot } from "../types";
import type { VirtualShiftListGroup, VirtualShiftListGroupHeader } from "./types";

interface BuildVirtualShiftListGroupProps {
  dateIso: string;
  shiftsForDate: OpenShiftListItem[];
  visibleTimeSlots: TimeSlot[];
}

export function buildVirtualShiftListGroup(
  props: BuildVirtualShiftListGroupProps
): VirtualShiftListGroup {
  const { dateIso, shiftsForDate, visibleTimeSlots } = props;

  const groupHeader: VirtualShiftListGroupHeader = {
    type: "group-header",
    dateIso,
    totalShiftsCount: shiftsForDate.length,
    visibleTimeSlots,
  };

  const group: VirtualShiftListGroup = {
    dateIso,
    shifts: shiftsForDate,
    listItems: [groupHeader],
  };

  shiftsForDate.forEach((shift) => {
    // This should eventually be for any shift list injection item not just in-app-ads
    // injected items do not have a time slot
    if (
      shift.type === "in-app-ad" ||
      shift.type === "fortune-cookie" ||
      shift.type === "worker-pay-survey"
    ) {
      group.listItems.push(shift);
      return;
    }

    const { timeSlot } = shift.attributes;

    if (visibleTimeSlots.length > 0 && !visibleTimeSlots.includes(timeSlot)) {
      return;
    }

    group.listItems.push(shift);
  });

  return group;
}
